import { Skeleton } from "../../../components";
import SocialCard from "@/components/SocialSetting/SocialCard";
import SocialCreate from "@/components/SocialSetting/SocialCreate";
import { useEffect, useState, useMemo } from "react";
import { RootState } from "../../../store";
import { ConnectedProps, connect } from "react-redux";
import { SocialChannel } from "@/store/app/app.models";
import Modal from "@/components/Modal/Modal";
import PageHeader from "@/components/Layout/PageHeader";
import { setUserSocialChannels } from "@/store/app/app.slice";
import { NoContentFound } from "@/utils/ui/NoContent";
import { getSocialChannels } from "@/store/app/app.actions";
//TODO -Have to add VideoCount

const SocialList = ({
  socialChannels,
  isLoading,
  setUserSocialChannels,
  getSocialChannels,
}: Props) => {
  const [socialPages, setSocialPages] = useState<SocialChannel[]>();
  const [isModalOpen, setModalOpen] = useState(false);

  const handleModalClose = () => {
    setModalOpen((prev) => !prev);
  };

  useEffect(() => {
    if (socialChannels) {
      setSocialPages(socialChannels);
    }
  }, [socialChannels]);

  const handleAddChannel = (channels: SocialChannel[]) => {
    setUserSocialChannels({ data: { list: [...socialChannels, ...channels] } });
    setTimeout(() => {
      getSocialChannels();
    }, 1500);
  };

  const skeletonCards = useMemo(() => {
    return [...Array(11)].map((_, index) => (
      <div className="col-sm-12 col-md-4 col-lg-3 mb-4" key={index}>
        <div className="border rounded">
          <div className="d-flex p-0" style={{ backgroundColor: "#f4f4f4" }}>
            <div className="col-sm-6 col-md-4 col-lg-5">
              <div className="ratio ratio-1x1">
                <Skeleton type="thumbnail" width="100%" height="100%" />
              </div>
            </div>
            <div className="p-2 d-flex flex-column flex-grow-1 gap-1">
              <div className="d-flex align-items-center gap-2">
                <Skeleton type="avatar" width={30} height={30} />
                <Skeleton type="text" width="120px" />
              </div>
              <Skeleton type="text" width="150px" />
              <Skeleton type="text" width="180px" />
              <Skeleton type="text" width="140px" />
            </div>
          </div>
          <div
            className="d-flex justify-content-between p-2 border"
            style={{ borderTop: "none" }}
          >
            <Skeleton type="text" width="80px" />
            <Skeleton type="text" width="100px" />
          </div>
        </div>
      </div>
    ));
  }, []);

  return (
    <div className="container">
      <PageHeader
        title="Social Connect"
        buttonText="Connect"
        onButtonClick={handleModalClose}
        backPath="/setting"
      />
      <div className="row p-4">
        {isLoading ? (
          skeletonCards
        ) : socialPages?.length && !isLoading ? (
          socialPages?.map((item: SocialChannel) => (
            <div className="social-connect" key={item.id}>
              <SocialCard item={item} />
            </div>
          ))
        ) : (
          <NoContentFound />
        )}
      </div>

      {isModalOpen && (
        <Modal
          isOpen={isModalOpen}
          onClose={handleModalClose}
          title="Create"
          width="600px"
          bgColor="bgGrey"
        >
          <SocialCreate
            handleAddChannel={handleAddChannel}
            handleModalClose={handleModalClose}
          />
        </Modal>
      )}
    </div>
  );
};

const mapState = (state: RootState) => ({
  socialChannels: state.app.userSocialChannels.socialChannelsList,
  isLoading: state.app.userSocialChannels.isLoading,
});

const mapDispatch = {
  setUserSocialChannels,
  getSocialChannels,
};
const connector = connect(mapState, mapDispatch);
type Props = ConnectedProps<typeof connector>;

export default connector(SocialList);
